import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import { useTheme } from '@emotion/react'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'

import ButtonText from '@segment/matcha/components/ButtonText'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import IconWrapper from '@segment/matcha/components/IconWrapper'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import { trackButtonClick } from '@segment/tracking/scripts'

import useStartupLinks from '@segment/utils/useStartupLinks'

import { cards } from './data'

const copy = {
  title: `Get $25,000 in Segment credits`,
}

const button = {
  text: `Apply now`,
}

const SegmentCredits: FC<PropsWithChildren<unknown>> = () => {
  const theme = useTheme()
  const { applyLink } = useStartupLinks()

  return (
    <Wrapper>
      <SectionBase variant="centered">
        <Section.Copy>
          <CopyTextBase centered={true}>
            <CopyText.Heading tag="h3">{copy.title}</CopyText.Heading>
          </CopyTextBase>
        </Section.Copy>
        <Section.Contents>
          <Body>
            <ColumnTrack columns={1} overrides={{ md: 2, lg: 4 }}>
              {cards(theme.palette.twilio.gray[100]).map((card) => (
                <FeatureBoxBase key={card.key} headerPosition="top" alignment="left">
                  <FeatureBox.Header>
                    <IconWrapper variant="circle" elevation={1}>
                      {card.icon}
                    </IconWrapper>
                  </FeatureBox.Header>
                  <FeatureBox.Body>
                    <FeatureBox.Title variant="h5" tag="h4">
                      {card.title}
                    </FeatureBox.Title>
                    <FeatureBox.Text variant="pMedium" tag="div">
                      {card.description}
                    </FeatureBox.Text>
                  </FeatureBox.Body>
                </FeatureBoxBase>
              ))}
            </ColumnTrack>
            <ButtonWrapper>
              <ButtonText
                tag="a"
                href={applyLink}
                onClick={() => trackButtonClick({ buttonText: button.text, targetUrl: applyLink })}
                iconEnd={ChevronRightIcon}
              >
                {button.text}
              </ButtonText>
            </ButtonWrapper>
          </Body>
        </Section.Contents>
      </SectionBase>
    </Wrapper>
  )
}

const Wrapper = styled.div``

const ButtonWrapper = styled.div`
  padding-top: 60px;
  text-align: center;
`

const Body = styled.div`
  max-width: 1120px;
  margin: 0 auto;
`

export default SegmentCredits
